import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const words = ['Transformando', 'Liderando'];

const PageLoader = ({ onComplete }) => {
  const [wordIndex, setWordIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setWordIndex((prev) => {
        if (prev >= words.length - 1) {
          clearInterval(interval);
          setTimeout(() => {
            setDone(true);
            setTimeout(onComplete, 400);
          }, 250);
          return prev;
        }
        return prev + 1;
      });
    }, 280);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          exit={{ opacity: 0, y: '-3%' }}
          transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 100000,
            background: 'var(--text-primary)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2rem',
            overflow: 'hidden',
          }}
        >
          {/* Decorative top-right corner */}
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 0.15, scale: 1 }}
            transition={{ duration: 0.8 }}
            style={{
              position: 'absolute',
              top: '-10%',
              right: '-10%',
              width: 500,
              height: 500,
              borderRadius: '50%',
              border: '60px solid var(--accent-gold-400)',
              pointerEvents: 'none',
            }}
          />

          {/* Main name */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(2rem, 6vw, 4rem)',
              fontWeight: 600,
              color: '#F5E6C8',
              letterSpacing: '-0.01em',
              textAlign: 'center',
            }}
          >
            Lucimar Bizoni
          </motion.div>

          {/* Animated word */}
          <div style={{ height: '2rem', overflow: 'hidden', position: 'relative' }}>
            <AnimatePresence mode="wait">
              <motion.p
                key={wordIndex}
                initial={{ y: '110%', opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: '-110%', opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '0.85rem',
                  fontWeight: 400,
                  color: 'var(--accent-gold-400)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.2em',
                  position: 'absolute',
                  whiteSpace: 'nowrap',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                {words[wordIndex]}
              </motion.p>
            </AnimatePresence>
          </div>

          {/* Loading bar */}
          <motion.div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              height: 2,
              background: 'linear-gradient(90deg, var(--accent-bronze-400), var(--accent-gold-400))',
            }}
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ duration: words.length * 0.28, ease: 'linear' }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageLoader;
